export default {
      id: "ar_agenda-usage",
      viewBox: "0 0 110 100",
      url: "../dist/images/" + "sprite.svg#ar_agenda-usage",
      toString: function () {
        return this.url;
      }
    }